import { render } from "./HelloWorld.vue?vue&type=template&id=47121986&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=47121986&scoped=true&lang=scss"

import exportComponent from "C:\\blissappp\\blissholidays\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47121986"]])

export default __exports__